import React from "react";
import { connect } from "react-redux";

import {
  getPaymentByID,
  getPaymentTotalOutstandingPrice,
  isPaymentOverdue,
  isPaymentSeen
} from "state/school_money/selectors";

import Date from "components/Date";
import Currency from "components/Currency";
import NewIndicator from "components/school_money/NewIndicator";
import PaymentBasketButton from "components/school_money/payments/PaymentBasketButton";

import "./PaymentHeader.css";

class PaymentHeader extends React.Component {
  
  getInstallmentCount() {
    return this.props.payment.get("installments").size;
  }
  
  hasMultipleInstallments() {
    return this.getInstallmentCount() > 1;
  }
  
  getInstallment() {
    return this.props.payment.get("installments").first();
  }
  
  getAnnotation() {
    const { isPartial, isVoluntary, isOfflineOnly } = this.props.payment.toObject();
    if (isOfflineOnly) {
      return "Offline Only";
    }
    if (this.hasMultipleInstallments()) {
      const installmentCount = this.getInstallmentCount();
      if (isVoluntary) {
        return `${installmentCount} Voluntary Payments`;
      }
      if (isPartial) {
        return `${installmentCount} Partial Payments`;
      }
      return `${installmentCount} Payments`;
    }
    if (isVoluntary) {
      return "Voluntary Payment";
    }
    if (isPartial) {
      return "Partial Payment";
    }
    return <Date date={this.getInstallment().get("dueDate")} />;
  }
  
  getStatus() {
    if (this.props.isOverdue) {
      return "Overdue";
    }
    return null;
  }
  
  render() {
    
    const { payment, paymentID, totalPrice, isOverdue, isSeen, limitedPlacesIndicator } = this.props;
    const { description, isOfflineOnly } = payment.toObject();
    const isSinglePaymentInstallment = !this.hasMultipleInstallments() && !payment.isVoluntary && !payment.isPartial;
    
    const classNames = [ "payment-header" ];
    if (isOverdue) {
      classNames.push("payment-header--overdue");
    }
    
    return (
      <div className={classNames.join(" ")}>
        { isSeen ? null : <NewIndicator className="payment-header__new-indicator" /> }
        <div className="payment-header__details">
          <div className="payment-header__text">
            <div className="payment-header__description">{description}</div>
            <div className={"payment-header__annotation" + (isSinglePaymentInstallment && isOverdue ? " payment-header__annotation--overdue" : "")}>{this.getAnnotation()}</div>
          </div>
          <div className="payment-header__controls">
            <div className="payment-header__price">
              <Currency amount={totalPrice} />
            </div>
            {
              isOfflineOnly || this.hasMultipleInstallments() ?
              null :
              <PaymentBasketButton
                cssBlockName="payment-header"
                paymentID={paymentID}
                installmentNumber={this.getInstallment().get("number")}
              />
            }
          </div>
        </div>
        { limitedPlacesIndicator }
        <div className="payment-header__status">{this.getStatus()}</div>
      </div>
    )
    
  }
  
}

export default connect(
  (state, { paymentID }) => ({
    payment: getPaymentByID(state, paymentID),
    totalPrice: getPaymentTotalOutstandingPrice(state, paymentID),
    isOverdue: isPaymentOverdue(state, paymentID),
    isSeen: isPaymentSeen(state, paymentID)
  })
)(PaymentHeader);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/PaymentHeader.js